export default __webpack_public_path__ + "static/media/Marty Stoilkov.f33a2046.png";